import actions from "./actions"
import { mutations } from "./mutations"
import getters from "./getters"
import { Technician } from "@/models/Technician"

export default {
	namespaced: true,
	state: (): Technician => {
		return {
			notification_preference: [],
			service_provider_id: 0,
			status_id: 0,
			first_name: '',
			last_name: '',
			image: '',
			zipcode: '',
			address: '',
			radius: 50,
			service_areas: new Set<number>(),
			market_id: 0,
			skills: new Set<number>(),
			email: '',
			company_name: '',
			phone: '',
			total_leads: 0,
			city: '',
			state: '',
			company_id: 0,
			company_owner_technician_id: 0,
			is_company: false,
			is_company_owner: false
		}
	},
	mutations,
	actions,
	getters
}
